import { render, staticRenderFns } from "./DashboardApuracao.vue?vue&type=template&id=3dd38884&scoped=true&lang=html&"
import script from "./DashboardApuracao.vue?vue&type=script&lang=js&"
export * from "./DashboardApuracao.vue?vue&type=script&lang=js&"
import style0 from "./DashboardApuracao.vue?vue&type=style&index=0&id=3dd38884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd38884",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/DashboardApuracao.vue
// module id = 1204
// module chunks = 28